/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import httpService from '@/core/http/http.service';
import serverContextStore from '@/shared/content/server-context.store';
import { AxiosRequestConfig } from 'axios';

export class ProductClient {

    getVendorInfo(vendorId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfVendorInfoModel> {
        let apiPathAndParams = '/api/vendorinfo/{vendorId}';
        if (vendorId === undefined || vendorId === null)
            throw new Error('The parameter "vendorId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{vendorId}', encodeURIComponent('' + vendorId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfVendorInfoModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/vendorinfo/{vendorId}-' + cancellationContextKey : undefined);
    }
    getProductsByEnvironmentMedia(mediaName: string | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfTaggedProductModelOf> {
        let apiPathAndParams = '/api/product/tagging/by-environment-media?';
        if (mediaName !== undefined && mediaName !== null)
            apiPathAndParams += 'mediaName=' + encodeURIComponent('' + mediaName) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfTaggedProductModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/tagging/by-environment-media-' + cancellationContextKey : undefined);
    }
    getProductSpotsBySku(skus: string[] | null | undefined, includePurchaseOptions: boolean | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductSpotModelOf> {
        let apiPathAndParams = '/api/product/spot/by-sku?';
        if (skus !== undefined && skus !== null)
            skus && skus.forEach(item => { apiPathAndParams += 'skus=' + encodeURIComponent('' + item) + '&'; });
        if (includePurchaseOptions === null)
            throw new Error('The parameter "includePurchaseOptions" cannot be null.');
        else if (includePurchaseOptions !== undefined)
            apiPathAndParams += 'includePurchaseOptions=' + encodeURIComponent('' + includePurchaseOptions) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductSpotModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/spot/by-sku-' + cancellationContextKey : undefined);
    }
    downloadProductFactSheet(sku: string | null, isPresale: boolean | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<string> {
        let apiPathAndParams = '/api/product/{sku}/product-fact-sheet/download?';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (isPresale === null)
            throw new Error('The parameter "isPresale" cannot be null.');
        else if (isPresale !== undefined)
            apiPathAndParams += 'isPresale=' + encodeURIComponent('' + isPresale) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<string>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/product-fact-sheet/download-' + cancellationContextKey : undefined);
    }
    printProductFactSheet(sku: string | null, printerName: string | null | undefined, isPresale: boolean | undefined, messageId?: string): Promise<ClientResponseOfString> {
        let apiPathAndParams = '/api/product/{sku}/product-fact-sheet/print?';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (printerName !== undefined && printerName !== null)
            apiPathAndParams += 'printerName=' + encodeURIComponent('' + printerName) + '&';
        if (isPresale === null)
            throw new Error('The parameter "isPresale" cannot be null.');
        else if (isPresale !== undefined)
            apiPathAndParams += 'isPresale=' + encodeURIComponent('' + isPresale) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfString>(apiUrl, messageId);
    }
    getProductDetail(id: string | null, configurationId: string | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductDetailModel> {
        let apiPathAndParams = '/api/product/{id}?';
        if (id === undefined || id === null)
            throw new Error('The parameter "id" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{id}', encodeURIComponent('' + id));
        if (configurationId !== undefined && configurationId !== null)
            apiPathAndParams += 'configurationId=' + encodeURIComponent('' + configurationId) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductDetailModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{id}-' + cancellationContextKey : undefined);
    }
    getProductsFromSameSeries(id: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductSpotModelOf> {
        let apiPathAndParams = '/api/product/{id}/products-from-same-series';
        if (id === undefined || id === null)
            throw new Error('The parameter "id" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{id}', encodeURIComponent('' + id));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductSpotModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{id}/products-from-same-series-' + cancellationContextKey : undefined);
    }
    getCareProducts(sku: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIEnumerableOfProductSpotModel> {
        let apiPathAndParams = '/api/product/{sku}/care-products';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIEnumerableOfProductSpotModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/care-products-' + cancellationContextKey : undefined);
    }
    getRecommendedProducts(sku: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIEnumerableOfProductSpotModel> {
        let apiPathAndParams = '/api/product/{sku}/recommended-products';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIEnumerableOfProductSpotModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/recommended-products-' + cancellationContextKey : undefined);
    }
    getFreightInformation(skus: string[] | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfDictionaryOfStringAndBoolean> {
        let apiPathAndParams = '/api/product/get-freight-information?';
        if (skus !== undefined && skus !== null)
            skus && skus.forEach(item => { apiPathAndParams += 'skus=' + encodeURIComponent('' + item) + '&'; });
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDictionaryOfStringAndBoolean>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/get-freight-information-' + cancellationContextKey : undefined);
    }
    getProductAddOns(sku: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIReadOnlyListOfProductAddOnModel> {
        let apiPathAndParams = '/api/product/{sku}/products-add-ons';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIReadOnlyListOfProductAddOnModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/products-add-ons-' + cancellationContextKey : undefined);
    }
    getProductAddOnsByMultipleSku(skus: string[] | null | undefined, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfIReadOnlyListOfProductAddOnModel> {
        let apiPathAndParams = '/api/product/products-add-ons?';
        if (skus !== undefined && skus !== null)
            skus && skus.forEach(item => { apiPathAndParams += 'skus=' + encodeURIComponent('' + item) + '&'; });
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfIReadOnlyListOfProductAddOnModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/products-add-ons-' + cancellationContextKey : undefined);
    }
    getDeliveryTimeForProduct(id: string | null, zipCode: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductDeliveryTimeModel> {
        let apiPathAndParams = '/api/product/{id}/delivery-time/{zipCode}';
        if (id === undefined || id === null)
            throw new Error('The parameter "id" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{id}', encodeURIComponent('' + id));
        if (zipCode === undefined || zipCode === null)
            throw new Error('The parameter "zipCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{zipCode}', encodeURIComponent('' + zipCode));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductDeliveryTimeModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{id}/delivery-time/{zipCode}-' + cancellationContextKey : undefined);
    }
    getClickAndCollectStoreInventoryStatus(id: string | null, basketId: string | null | undefined, messageId?: string): Promise<ClientResponseOfProductClickAndCollectStoreInventoryResultOf> {
        let apiPathAndParams = '/api/product/{id}/inventory/click-and-collect-store-inventory?';
        if (id === undefined || id === null)
            throw new Error('The parameter "id" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{id}', encodeURIComponent('' + id));
        if (basketId !== undefined && basketId !== null)
            apiPathAndParams += 'basketId=' + encodeURIComponent('' + basketId) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfProductClickAndCollectStoreInventoryResultOf>(apiUrl, messageId);
    }
    getUpSellProducts(id: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfStringOf> {
        let apiPathAndParams = '/api/product/{id}/up-sell';
        if (id === undefined || id === null)
            throw new Error('The parameter "id" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{id}', encodeURIComponent('' + id));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfStringOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{id}/up-sell-' + cancellationContextKey : undefined);
    }
    getOutletProductDetailsByInventSerialId(inventSerialId: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfOutletProductDetailsModel> {
        let apiPathAndParams = '/api/outlet/{inventSerialId}';
        if (inventSerialId === undefined || inventSerialId === null)
            throw new Error('The parameter "inventSerialId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{inventSerialId}', encodeURIComponent('' + inventSerialId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfOutletProductDetailsModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/outlet/{inventSerialId}-' + cancellationContextKey : undefined);
    }
    getOutletProductDetailsBySku(sku: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfOutletProductDetailsModel> {
        let apiPathAndParams = '/api/outlet/c/{sku}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfOutletProductDetailsModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/outlet/c/{sku}-' + cancellationContextKey : undefined);
    }
    getDeliveryTimeForConfiguration(moduleConfigurationId: string, zipCode: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductDeliveryTimeModel> {
        let apiPathAndParams = '/api/product/module-configurator/{moduleConfigurationId}/delivery-time/{zipCode}';
        if (moduleConfigurationId === undefined || moduleConfigurationId === null)
            throw new Error('The parameter "moduleConfigurationId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleConfigurationId}', encodeURIComponent('' + moduleConfigurationId));
        if (zipCode === undefined || zipCode === null)
            throw new Error('The parameter "zipCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{zipCode}', encodeURIComponent('' + zipCode));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductDeliveryTimeModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/module-configurator/{moduleConfigurationId}/delivery-time/{zipCode}-' + cancellationContextKey : undefined);
    }
    getMaterialAndColorCustomizer(sku: string | null, customizerId: string, selectedCustomizerId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfMaterialAndColorCustomizerModel> {
        let apiPathAndParams = '/api/product/{sku}/customizer/material-color/{customizerId}/{selectedCustomizerId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerId === undefined || selectedCustomizerId === null)
            throw new Error('The parameter "selectedCustomizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerId}', encodeURIComponent('' + selectedCustomizerId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfMaterialAndColorCustomizerModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/material-color/{customizerId}/{selectedCustomizerId}-' + cancellationContextKey : undefined);
    }
    getProductFamilyCustomizerTabFacet(sku: string | null, customizerId: string, selectedCustomizerTabId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfCustomizerTabFacet> {
        let apiPathAndParams = '/api/product/{sku}/customizer/facets/product-family/{customizerId}/{selectedCustomizerTabId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerTabId === undefined || selectedCustomizerTabId === null)
            throw new Error('The parameter "selectedCustomizerTabId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerTabId}', encodeURIComponent('' + selectedCustomizerTabId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCustomizerTabFacet>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/facets/product-family/{customizerId}/{selectedCustomizerTabId}-' + cancellationContextKey : undefined);
    }
    getMaterialAndColorCustomizerTabFacet(sku: string | null, customizerId: string, selectedCustomizerTabId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfCustomizerTabFacet> {
        let apiPathAndParams = '/api/product/{sku}/customizer/facets/material-color/{customizerId}/{selectedCustomizerTabId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerTabId === undefined || selectedCustomizerTabId === null)
            throw new Error('The parameter "selectedCustomizerTabId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerTabId}', encodeURIComponent('' + selectedCustomizerTabId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCustomizerTabFacet>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/facets/material-color/{customizerId}/{selectedCustomizerTabId}-' + cancellationContextKey : undefined);
    }
    getDefaultCustomizerTabFacet(sku: string | null, customizerId: string, selectedCustomizerTabId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfCustomizerTabFacet> {
        let apiPathAndParams = '/api/product/{sku}/customizer/facets/default/{customizerId}/{selectedCustomizerTabId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerTabId === undefined || selectedCustomizerTabId === null)
            throw new Error('The parameter "selectedCustomizerTabId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerTabId}', encodeURIComponent('' + selectedCustomizerTabId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCustomizerTabFacet>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/facets/default/{customizerId}/{selectedCustomizerTabId}-' + cancellationContextKey : undefined);
    }
    getComfortCustomizerTabFacet(sku: string | null, customizerId: string, selectedCustomizerTabId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfCustomizerTabFacet> {
        let apiPathAndParams = '/api/product/{sku}/customizer/facets/comfort/{customizerId}/{selectedCustomizerTabId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerTabId === undefined || selectedCustomizerTabId === null)
            throw new Error('The parameter "selectedCustomizerTabId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerTabId}', encodeURIComponent('' + selectedCustomizerTabId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCustomizerTabFacet>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/facets/comfort/{customizerId}/{selectedCustomizerTabId}-' + cancellationContextKey : undefined);
    }
    getLegsCustomizerTabFacet(sku: string | null, customizerId: string, selectedCustomizerTabId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfCustomizerTabFacet> {
        let apiPathAndParams = '/api/product/{sku}/customizer/facets/legs/{customizerId}/{selectedCustomizerTabId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerTabId === undefined || selectedCustomizerTabId === null)
            throw new Error('The parameter "selectedCustomizerTabId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerTabId}', encodeURIComponent('' + selectedCustomizerTabId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCustomizerTabFacet>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/facets/legs/{customizerId}/{selectedCustomizerTabId}-' + cancellationContextKey : undefined);
    }
    getProductFamilyCustomizers(sku: string | null, customizerId: string, selectedCustomizerTabId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductFamilyCustomizerModel> {
        let apiPathAndParams = '/api/product/{sku}/customizer/product-family-customizers/{customizerId}/{selectedCustomizerTabId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerTabId === undefined || selectedCustomizerTabId === null)
            throw new Error('The parameter "selectedCustomizerTabId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerTabId}', encodeURIComponent('' + selectedCustomizerTabId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductFamilyCustomizerModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/product-family-customizers/{customizerId}/{selectedCustomizerTabId}-' + cancellationContextKey : undefined);
    }
    getProductComfortCustomizer(sku: string | null, customizerId: string, selectedCustomizerTabId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfComfortCustomizerModelOf> {
        let apiPathAndParams = '/api/product/{sku}/customizer/comfort/{customizerId}/{selectedCustomizerTabId}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        if (customizerId === undefined || customizerId === null)
            throw new Error('The parameter "customizerId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{customizerId}', encodeURIComponent('' + customizerId));
        if (selectedCustomizerTabId === undefined || selectedCustomizerTabId === null)
            throw new Error('The parameter "selectedCustomizerTabId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{selectedCustomizerTabId}', encodeURIComponent('' + selectedCustomizerTabId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfComfortCustomizerModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/{sku}/customizer/comfort/{customizerId}/{selectedCustomizerTabId}-' + cancellationContextKey : undefined);
    }
}

export const ProductClientService = new ProductClient();

export class ProductInternalModuleConfiguratorClient {

    saveModuleConfiguration(configurationId: string, request: SaveModuleConfigurationRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/product/module-configurator/configuration/{configurationId}';
        if (configurationId === undefined || configurationId === null)
            throw new Error('The parameter "configurationId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{configurationId}', encodeURIComponent('' + configurationId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponse>(apiUrl, request, messageId);
    }
    getModuleConfiguration(configurationId: string, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfModuleConfigurationModel> {
        let apiPathAndParams = '/api/product/module-configurator/configuration/{configurationId}';
        if (configurationId === undefined || configurationId === null)
            throw new Error('The parameter "configurationId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{configurationId}', encodeURIComponent('' + configurationId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfModuleConfigurationModel>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/module-configurator/configuration/{configurationId}-' + cancellationContextKey : undefined);
    }
}

export const ProductInternalModuleConfiguratorClientService = new ProductInternalModuleConfiguratorClient();

export class ProductModuleConfiguratorClient {

    getModules(familyName: string | null, cancellationContextKey?: string, messageId?: string, config: AxiosRequestConfig = {}): Promise<ClientResponseOfProductModuleModelOf> {
        let apiPathAndParams = '/api/product/module-configurator/{familyName}/modules';
        if (familyName === undefined || familyName === null)
            throw new Error('The parameter "familyName" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{familyName}', encodeURIComponent('' + familyName));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductModuleModelOf>(apiUrl, {}, { ...config, messagesId: messageId }, cancellationContextKey ? 'api/product/module-configurator/{familyName}/modules-' + cancellationContextKey : undefined);
    }
}

export const ProductModuleConfiguratorClientService = new ProductModuleConfiguratorClient();

export interface ClientResponseOfVendorInfoModel {
    model: VendorInfoModel | undefined;
    messages: ClientMessage[];
}

export interface VendorInfoModel {
    id: string;
    name: string;
    valutaCode: string;
    vendorTitle: string | undefined;
    vendorDescription: string | undefined;
}

export interface ClientMessage {
    labelKey: string | undefined;
    message: string;
    messageType: ClientMessageType;
}

export enum ClientMessageType {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export interface ClientResponse {
    messages: ClientMessage[];
}

export interface ClientResponseOfTaggedProductModelOf {
    model: TaggedProductModel[] | undefined;
    messages: ClientMessage[];
}

export interface TaggedProductModel {
    sku: string;
    purchaseOption: PurchaseOptionType | undefined;
    quantityMultiplier: number;
}

export enum PurchaseOptionType {
    Instant = 0,
    PickAndPack = 1,
    ClickAndCollect = 2,
    Standard = 3,
    Special = 4,
    B2BStandard = 5,
    InStoreOnly = 6,
    B2BExpress = 7,
    ModuleConfiguration = 8,
}

export interface ClientResponseOfProductSpotModelOf {
    model: ProductSpotModel[] | undefined;
    messages: ClientMessage[];
}

export interface ProductSpotModel {
    id: number;
    sku: string;
    name: string;
    price: ProductPriceModel;
    imageProperties: ImageProperties | undefined;
    quantityMultiplier: number;
    lightingSpecification: LightingSpecification | undefined;
    certificates: Certificate[] | undefined;
    isPickAndPack: boolean;
    description: string | undefined;
    labels: ProductLabel[] | undefined;
    designerName: string | undefined;
    familyName: string | undefined;
    ean: string | undefined;
    metaData: ProductMetaData;
    fromPrice: BoliaMoney | undefined;
    purchaseOptions: PurchaseOption[];
}

export interface ProductPriceModel {
    listPrice: BoliaMoney;
    salesPrice: BoliaMoney;
    ecoTaxPrice: BoliaMoney | undefined;
    discount: ProductBaseDiscount | undefined;
    priceValidUntil: Date | undefined;
}

export interface BoliaMoney {
    rawAmount: number;
    amount: string;
    currency: string;
}

export interface ProductBaseDiscount {
    type: ProductDiscountType;
    discount: BoliaMoney;
    percentage: number;
    expiryLabel: LabelWithNamedArguments | undefined;
    discriminator: string;
}

export enum ProductDiscountType {
    Campaign = 0,
    MyBoliaBoost = 1,
}

export interface LabelWithNamedArguments {
    label: string;
    severity: LabelSeverity;
    namedParams: { [key: string]: any; };
}

export enum LabelSeverity {
    Error = 0,
    Warning = 1,
    Information = 2,
}

export interface ProductCampaignDiscount extends ProductBaseDiscount {
}

export interface ProductMyBoliaBoostDiscount extends ProductBaseDiscount {
}

export interface ImageProperties {
    version: number;
    type: DefaultImageType;
}

export enum DefaultImageType {
    Default = 0,
    Angle = 1,
}

export interface LightingSpecification {
    specificationUrl: string | undefined;
    energyClassification: string | undefined;
    energyClassificationUrl: string | undefined;
}

export interface Certificate {
    name: string;
    imageUrl: string | undefined;
    code: string;
    imageVersion: number | undefined;
}

export interface ProductLabel {
    type: ProductLabelType;
    text: string | undefined;
    backgroundColorHex: string | undefined;
}

export enum ProductLabelType {
    NewArrival = 0,
    Customize = 1,
    ProductSpot = 2,
}

export interface ProductMetaData {
    family: string | undefined;
    retailHierarchy: string | undefined;
    businessArea: string | undefined;
    brand: string | undefined;
    ean: string | undefined;
}

export interface PurchaseOption {
    type: PurchaseOptionType;
    sortOrder: number;
    quantityMultiplier: number;
    discriminator: string;
}

export interface StandardPurchaseOption extends PurchaseOption {
    title: string | undefined;
    description: string | undefined;
}

export interface InstantPurchaseOption extends PurchaseOption {
    title: string;
}

export interface PickAndPackPurchaseOption extends PurchaseOption {
    backOrderAvailable: boolean;
    title: string;
    description: string | undefined;
}

export interface ClickAndCollectPurchaseOption extends PurchaseOption {
    backOrderAvailable: boolean;
    title: string;
}

export interface SpecialDeliveryPurchaseOption extends PurchaseOption {
    findStoreAndDealersTitle: string;
    specialDeliveryTitle: string;
    specialDeliveryDescription: string;
}

export interface B2BStandardPurchaseOption extends PurchaseOption {
    title: string;
}

export interface InStoreOnlyPurchaseOption extends PurchaseOption {
    title: string;
    description: string | undefined;
}

export interface B2BExpressPurchaseOption extends PurchaseOption {
    title: string;
}

export interface ModuleConfigurationPurchaseOption extends PurchaseOption {
    title: string | undefined;
}

export interface ClientResponseOfString {
    model: string | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfProductDetailModel {
    model: ProductDetailModel | undefined;
    messages: ClientMessage[];
}

export interface ProductDetailModel {
    id: string;
    productId: string;
    name: string;
    fullName: string;
    designer: string | undefined;
    imageProperties: ImageProperties[] | undefined;
    specifications: Specifications;
    seriesInformation: SeriesInformation | undefined;
    coverMaterial: ProductDetailCoverMaterial | undefined;
    lightingSpecification: LightingSpecification | undefined;
    isGiftPackingAllowed: boolean;
    quantityMultiplier: number;
    price: ProductPriceModel;
    purchasePossibilities: PurchaseOption[];
    hasFreightInformation: boolean;
    showCalculateDeliveryTimeOption: boolean;
    customizerModel: CustomizerModel | undefined;
    familyName: string | undefined;
    climateEmissionCollection: ClimateEmissionCollection | undefined;
    productLabels: ProductLabel[] | undefined;
    itemAvailability: ItemAvailability;
    productJsonLd: ProductSchema | undefined;
    productSpotLabel: ProductSpotLabel | undefined;
    primaryVendorId: string | undefined;
    metaData: ProductMetaData;
    productAddOnCount: number;
    isConfigurable: boolean;
    productTransparencyDetails: ProductDetailTransparencyModel | undefined;
    hasBuyXAndGetYDiscountOption: boolean | undefined;
}

export interface Specifications {
    ean: string | undefined;
    productInformationAttributes: SpecificationAttribute[] | undefined;
    productSpecificationAttributes: SpecificationAttribute[] | undefined;
    collis: Colli[] | undefined;
    certificates: Certificate[] | undefined;
    tests: Test[] | undefined;
    downLoads: ProductDetailDownload[] | undefined;
    hasProductFactSheet: boolean;
}

export interface SpecificationAttribute {
    name: string;
    label: string;
    value: string;
}

export interface Colli {
    id: string;
    number: number;
    unitVolume: number;
    height: number;
    width: number;
    depth: number;
    grossWeight: number;
}

export interface Test {
    name: string;
    documentUrl: string | undefined;
}

export interface ProductDetailDownload {
    label: string;
    url: string;
}

export interface SeriesInformation {
    description: string;
    uniqueSellingPoints: string[];
}

export interface CoverMaterial {
    name: string;
    materialType: string;
    martinDale: string | undefined;
    pilling: string | undefined;
    lightFastness: string | undefined;
    shortDescription: string;
    description: string;
    recommendation: string;
    imageName: string | undefined;
    compositions: MaterialComposition[];
    color: Color;
    fabricClimateEmission: FabricClimateEmission | undefined;
    countryOfOrigin: string | undefined;
    fabricCertificates: FabricCertificate[] | undefined;
    fabricTests: FabricTest[] | undefined;
    washingInstructions: string[] | undefined;
}

export interface ProductDetailCoverMaterial extends CoverMaterial {
    image: CacheBustImage | undefined;
}

export interface CacheBustImage {
    path: string;
    cacheBust: number;
}

export interface MaterialComposition {
    percentage: number | undefined;
    material: string;
}

export interface Color {
    code: string | undefined;
    name: string;
    baseColor: string;
}

export interface FabricClimateEmission {
    climateEmission: ClimateEmission;
    documentationUrl: string | undefined;
}

export interface ClimateEmission {
    emissionValue: string;
    screeningSpecification: string;
}

export interface FabricCertificate extends Certificate {
}

export interface FabricTest extends Test {
}

export interface CustomizerModel {
    id: string;
    alias: string;
    tabs: CustomizerTabModel[];
}

export interface CustomizerTabModel {
    id: string;
    alias: string;
    title: string;
    description: string;
    type: CustomizerTabType;
}

export enum CustomizerTabType {
    Default = 0,
    Variant = 1,
    ProductFamily = 2,
    MaterialAndColor = 3,
    Comfort = 4,
    Legs = 5,
}

export interface ClimateEmissionCollection {
    climateEmissions: ClimateEmission[];
    documentationUrl: string | undefined;
    totalEmissionDescription: string | undefined;
}

export enum ItemAvailability {
    Discontinued = 0,
    InStock = 1,
    InStoreOnly = 2,
    LimitedAvailability = 3,
    OnlineOnly = 4,
    OutOfStock = 5,
    PreOrder = 6,
    SoldOut = 7,
}

export interface Thing {
    name: string | undefined;
    url: string | undefined;
    description: string | undefined;
    image: string[] | undefined;
    "@type": string;
}

export interface ProductSchema extends Thing {
    productID: string;
    sku: string;
    brand: Thing | undefined;
    offers: OfferSchema[];
    "@content": string;
}

export interface OfferSchema extends Thing {
    price: string;
    priceCurrency: string;
    availability: string;
    priceValidUntil: string | undefined;
}

export interface ProductSpotLabel {
    text: string;
    hexColorCode: string;
}

export interface ProductDetailTransparencyModel {
    categories: ProductTransparencyCategoryModel[];
}

export interface ProductTransparencyCategoryModel {
    id: string;
    header: string;
    title: string;
    description: string | undefined;
    logoImage: CacheBustImage | undefined;
    specifications: KeyValuePairOfStringAndString[] | undefined;
    crossSectionDocumentUrl: string | undefined;
}

export interface KeyValuePairOfStringAndString {
    key: string;
    value: string;
}

export interface ClientResponseOfIEnumerableOfProductSpotModel {
    model: ProductSpotModel[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfDictionaryOfStringAndBoolean {
    model: { [key: string]: boolean; } | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfIReadOnlyListOfProductAddOnModel {
    model: ProductAddOnModel[] | undefined;
    messages: ClientMessage[];
}

export interface ProductAddOnModel {
    name: string;
    sku: string;
    imageProperties: ImageProperties[];
    recommendedQuantity: number;
    price: ProductAddOnPriceModel;
    productUrl: string | undefined;
    purchaseOptions: PurchaseOption[];
    ean: string | undefined;
    familyName: string | undefined;
    designerName: string | undefined;
    metaData: ProductMetaData | undefined;
}

export interface ProductAddOnPriceModel extends ProductPriceModel {
    salesPriceTotal: BoliaMoney;
    ecoTaxPriceTotal: BoliaMoney | undefined;
}

export interface ClientResponseOfProductDeliveryTimeModel {
    model: ProductDeliveryTimeModel | undefined;
    messages: ClientMessage[];
}

export interface ProductDeliveryTimeModel {
    label: LabelWithNamedArguments;
}

export interface ClientResponseOfProductClickAndCollectStoreInventoryResultOf {
    model: ProductClickAndCollectStoreInventoryResult[] | undefined;
    messages: ClientMessage[];
}

export interface ProductClickAndCollectStoreInventoryResult {
    storeId: string;
    storeTitle: string;
    status: LabelWithNamedArguments;
}

export interface ClientResponseOfStringOf {
    model: string[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfOutletProductDetailsModel {
    model: OutletProductDetailsModel | undefined;
    messages: ClientMessage[];
}

export interface OutletProductDetailsModel {
    fullName: string;
    isConsignment: boolean;
    itemsInStock: number;
    inventSerial: string | undefined;
    recId: number;
    damageDescriptions: string[] | undefined;
    canBeDelivered: boolean;
    originalSku: string;
    quantityMultiplier: number;
    damageTypes: DamageType[];
    familyName: string | undefined;
    originalDiscontinued: boolean;
    imageProperties: ImageProperties[] | undefined;
    specifications: Specifications | undefined;
    seriesInformation: SeriesInformation | undefined;
    coverMaterial: ProductDetailCoverMaterial | undefined;
    lightingSpecification: LightingSpecification | undefined;
    price: ProductPriceModel;
    customizerTabModels: CustomizerTabModel[] | undefined;
    outletLocation: OutletLocation | undefined;
    designer: DesignerDto | undefined;
    damageImages: string[] | undefined;
    showLinkToProductPage: boolean;
    primaryVendorId: string | undefined;
    productAddOnCount: number;
    metaData: ProductMetaData;
    productTransparencyDetails: ProductDetailTransparencyModel | undefined;
    productLabels: ProductLabel[] | undefined;
}

export enum DamageType {
    PackingDamaged = 0,
    ItemDamaged = 1,
}

export interface OutletLocation {
    inventoryLocationId: string;
    storeId: string | undefined;
    hub: string;
    name: string;
    isStorage: boolean;
}

export interface DesignerDto {
    id: string;
    name: string;
}

export interface SaveModuleConfigurationRequest {
    configuration: any;
    name: string;
    images: ModuleConfigurationImage[];
    dimensions: ModuleConfigurationDimensions;
    modules: Module[];
}

export interface ModuleConfigurationImage {
    content: string;
}

export interface ModuleConfigurationDimensions {
    depth: number;
    height: number;
    width: number;
}

export interface Module {
    sku: string;
    quantity: number;
}

export interface ClientResponseOfModuleConfigurationModel {
    model: ModuleConfigurationModel | undefined;
    messages: ClientMessage[];
}

export interface ModuleConfigurationModel {
    images: ModuleConfigurationImage[];
    dimensions: ModuleConfigurationDimensions | undefined;
    configuration: any;
}

export interface ClientResponseOfMaterialAndColorCustomizerModel {
    model: MaterialAndColorCustomizerModel | undefined;
    messages: ClientMessage[];
}

export interface MaterialAndColorCustomizerModel {
    materials: MaterialModel[];
    facets: CustomizerFacetViewModel[];
}

export interface MaterialModel {
    coverName: string | undefined;
    materialTypeName: string | undefined;
    materialTypeNameValue: string | undefined;
    name: string | undefined;
    count: number;
    isBestSeller: boolean;
    isSelected: boolean;
    materialCover: MaterialCover;
    variantWithPrices: MaterialAndColorVariant[];
    fabricCertificates: FabricCertificate[];
    fabricTests: FabricTest[];
}

export interface MaterialCover {
    name: string;
    materialType: string;
    materialTypeValue: string;
    martinDale: string | undefined;
    pilling: string | undefined;
    lightFastness: string | undefined;
    shortDescription: string | undefined;
    compositions: MaterialComposition2[];
    fabricClimateEmission: FabricClimateEmission | undefined;
    fabricCertificates: FabricCertificate[] | undefined;
    fabricTests: FabricTest[] | undefined;
    washingInstructions: string[] | undefined;
}

export interface MaterialComposition2 {
    material: string;
    percentage: number | undefined;
}

export interface MaterialAndColorVariant {
    sku: string;
    name: string;
    color: string | undefined;
    colorValue: string | undefined;
    coverName: string | undefined;
    price: ProductPriceModel | undefined;
    materialImage: CacheBustImage | undefined;
    materialType: string | undefined;
    materialTypeValue: string | undefined;
    selected: boolean;
    hexColor: string | undefined;
}

export interface CustomizerFacetViewModel {
    id: string;
    title: string | undefined;
    options: FacetOptions[];
}

export interface FacetOptions {
    title: string | undefined;
    value: string | undefined;
    selected: boolean;
    hexColor: string | undefined;
    count: number;
    description: string | undefined;
}

export interface ClientResponseOfCustomizerTabFacet {
    model: CustomizerTabFacet | undefined;
    messages: ClientMessage[];
}

export interface CustomizerTabFacet {
    type: CustomizerTabFacetType;
    action: LabelWithNamedArguments | undefined;
    dimensions: CustomizerDimension[];
}

export enum CustomizerTabFacetType {
    WithDimensions = 0,
    WithOutDimensions = 1,
}

export interface CustomizerDimension {
    type: CustomizerOptionDisplayType;
    options: CustomizerOption[];
}

export enum CustomizerOptionDisplayType {
    Swatch = 0,
    Text = 1,
    Undefined = 99,
}

export interface CustomizerOption {
    sku: string;
    title: string | undefined;
    selected: boolean;
    discriminator: string;
}

export interface SwatchColorImageCustomizerOption extends CustomizerOption {
    hexCode: string | undefined;
    image: CacheBustImage | undefined;
}

export interface TextCustomizerOption extends CustomizerOption {
}

export interface ClientResponseOfProductFamilyCustomizerModel {
    model: ProductFamilyCustomizerModel | undefined;
    messages: ClientMessage[];
}

export interface ProductFamilyCustomizerModel {
    results: ProductSpotModel[];
}

export interface ClientResponseOfComfortCustomizerModelOf {
    model: ComfortCustomizerModel[] | undefined;
    messages: ClientMessage[];
}

export interface ComfortCustomizerModel {
    name: string | undefined;
    description: string | undefined;
    sku: string;
    image: CacheBustImage;
    price: ProductPriceModel;
    selected: boolean;
}

export interface ClientResponseOfProductModuleModelOf {
    model: ProductModuleModel[] | undefined;
    messages: ClientMessage[];
}

export interface ProductModuleModel {
    productId: string;
    name: string;
    familyName: string;
    designer: string | undefined;
    dimensions: DimensionsModel;
    specifications: VariantConfigurationSpecificationModel[];
    variants: VariantModuleModel[];
}

export interface DimensionsModel {
    netDepth: number | undefined;
    netWidth: number | undefined;
    netLength: number | undefined;
    netHeight: number | undefined;
    seatDepth: number | undefined;
    seatHeight: number | undefined;
}

export interface VariantConfigurationSpecificationModel {
    label: string;
    value: string;
}

export interface VariantModuleModel {
    sku: string;
    sofaLegs: SofaLegsModel | undefined;
    price: VariantModulePriceModel;
    coverMaterial: VariantModuleCoverMaterialModel | undefined;
}

export interface SofaLegsModel {
    name: string;
    materialImage: MaterialImageModel;
}

export interface MaterialImageModel {
    name: string;
    url: string;
}

export interface VariantModulePriceModel {
    listPrice: ModuleBoliaMoney;
    discount: VariantModuleDiscountModel | undefined;
    salesPrice: ModuleBoliaMoney;
    ecoTax: ModuleBoliaMoney | undefined;
}

export interface ModuleBoliaMoney {
    amount: string;
    currency: string;
    rawAmount: number;
}

export interface VariantModuleDiscountModel {
    discount: ModuleBoliaMoney;
    type: string;
    percentage: number;
    expiresDate: Date | undefined;
}

export interface VariantModuleCoverMaterialModel {
    name: string;
    materialType: string;
    image: MaterialImageModel | undefined;
    color: MaterialColorModel;
}

export interface MaterialColorModel {
    code: string | undefined;
    name: string;
    baseColor: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}